import { UseQueryOptions } from "@tanstack/react-query";
import { IService, ServiceType } from "../library/models/service";
import { BaseService } from "./baseService";

/** What the endpoint's `type` filter accepts. 'ALL' is a request, not a kind of service. */
export type ServiceTypeFilter = ServiceType | 'ALL';

export class ServicesService extends BaseService {
    /**
     * The clinic's services.
     *
     * Passing nothing means single sessions only, which is what the booking wizard wants
     * -- a package is sold at the desk rather than booked into a slot. The default lives
     * on the server as well, so this is a convenience rather than the guard.
     */
    getServices(type?: ServiceTypeFilter): UseQueryOptions<IService[], Error> {
        return this.createGetQuery<IService[]>('/services', type ? { type } : undefined);
    }
}
